import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService, SelectItem, SelectItemGroup } from 'primeng/api';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ORDER_DOCUMENT_TYPES } from 'projects/core/src/lib/constants';
import { FileMode, FileSettings } from 'projects/core/src/lib/types/filesettings.type';
@Component({
  selector: 'app-orderform-documents',
  templateUrl: './orderform-documents.component.html',
  styleUrls: ['./orderform-documents.component.scss']
})
export class PlannerOrderformDocumentsComponent implements OnInit {

  @Input() form: UntypedFormGroup;
  @Input() options: { [key: string]: Array<SelectItem | SelectItemGroup> };
  @Input() texts: { [key: string]: string };
  @Input() needsJobDescription = false;

  public hasJobError = false;

  public files: Array<File> = [];
  public settings: FileSettings = {};

  public fileForm: UntypedFormGroup = this.fb.group({});
  public optionsDocumenttypes: Array<SelectItem> = [];

  constructor(
    private fb: UntypedFormBuilder,
    private confirmation: ConfirmationService,
    private helper: HelperService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.form.addControl('documents', this.fileForm);
    this.optionsDocumenttypes = FormHelper.getSelectList(ORDER_DOCUMENT_TYPES, this.transloco.translate('common.labels.please_choose'), this.transloco)
      .filter((option: SelectItem) => option.value !== 'man_report');
  }

  public getPayload(): any {
    const payload: any = {};
    Object.keys(this.settings).forEach((key: string) => {
      const setting = this.settings[key];
      if (setting !== undefined) {
        payload[key] = {
          id: setting.id,
          name: setting.name,
          mode: setting.mode,
          type: setting.control?.value
        };
      }
    });
    return payload;
  }

  public getFiles(): Array<File> {
    return this.files;
  }

  public setFiles(event: any): void {
    if (Array.isArray(event.currentFiles)) {
      event.currentFiles.forEach((file: File) => {
        if (this.settings[file.name] === undefined) {
          const control = new UntypedFormControl('', [Validators.required]);
          this.settings[file.name] = {
            id: null,
            name: file.name,
            size: this.helper.getFileSize(file.size),
            mode: FileMode.Create,
            control
          };
          if (!this.fileForm.get(file.name)) {
            this.fileForm.addControl(file.name, control);
          }
        }
      });
    }
    this.files = event.currentFiles;
    this.fileForm.updateValueAndValidity();
    // preset job_description if necessary
    if (this.needsJobDescription === true && this.files.length === 1) {
      const file = this.files[0];
      const option = this.optionsDocumenttypes.find((documenttype: SelectItem) => {
        return documenttype.value === 'job_description';
      });
      if (option !== undefined) {
        this.settings[file.name].control?.setValue(option?.value);
      }
    }
  }

  public removeFile(file: File): void {
    this.confirmation.confirm({
      message: this.transloco.translate('common.messages.really_delete', { value: this.settings[file.name]?.name }),
      header: this.transloco.translate('common.really_delete'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.files = this.files.filter((actualFile: File) => {
          return file.name !== actualFile.name;
        });
        delete this.settings[file.name];
      }
    });
  }

  public clearFiles(): void {
    this.files = [];
  }

}
